export default {"src":"/_next/static/media/generalError.d890532c.svg","height":449,"width":690};